import { API_BASE_URL, HEADERS_WITH_TOKEN } from "services/api/BaseUrl"

export const getAll = async () => {

  const res = await fetch(
    `${API_BASE_URL}/payment-plans`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}

export const createPaymentIntent = async (amount) => {
  if(amount !== null) {
  const usr = JSON.parse(localStorage.getItem('mqadusr'))

  const res = await fetch(
    `${API_BASE_URL}/stripe/create-payment-intent`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify({ amount: amount, customerId: usr.stripe_customer_id })
    }
  )
  return await res.json()
  } else {
    return null
  }
}